<template>
  <div class="modal">
    <div class="modal-content">
      <h3>Have Any Additional Requests? Drop Them Here!</h3>
      <input
        type="text"
        placeholder="Make it Spicy..."
        v-model="additionalRequest"
      />
      <button @click="closeModal">Request!</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "CartAdditionalRequestModal",
  props: ["additionalRequests"],
  data() {
    return {
      additionalRequest: this.additionalRequests,
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-modal", this.additionalRequest);
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 101;
  //position: absolute;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(0, 0, 0, 0.7);

  .modal-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 8px;
    width: 300px;
    padding: 40px 30px;
    background-color: #fff;

    h3 {
      text-align: center;
      font-size: 17px;
      margin-bottom: 20px;
    }

    input {
      border: none;
      background-color: #f1f1f1;
      height: 50px;
      padding: 8px;
      &:focus {
        outline: none;
      }
    }

    button {
      cursor: pointer;
      align-self: center;
    }
  }
}
</style>
